import React, { useEffect, useState } from 'react'
import WorkflowCard from '../../../../component-controller-mod/component-serv/dashboard-fs-cp/workflow-dsb-op/workflow-card/ts/workflowCard'
import { getDataOverview, WORKFLOW_CARDS, WorkflowStatCard } from './workflow.type'
import "../css/ursb-workflow.css"

const UsrbWorkflow = () => {
  const [cards, setCards] = useState<WorkflowStatCard[]>(WORKFLOW_CARDS);

  useEffect(() => {
    fetchOverview();
  }, []);

  const fetchOverview = async () => {
    try {
      const res = await getDataOverview();
      const workflow = res.data?.data?.workflow;

      const updatedCards = WORKFLOW_CARDS.map((card) => ({
        ...card,
        value: workflow?.[card.id as keyof typeof workflow] ?? 0,
      }));

      setCards(updatedCards);
    } catch (error) {
      console.error("Failed to fetch overview", error);
    }
  };

  return (
    <section className='scl--uwf-sec-sty-container'>
      {cards.map((card) => (
        <WorkflowCard key={card.id} {...card} />
      ))}
    </section>
  );
};

export default UsrbWorkflow